import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const emailNotificationsLogAccessRoute: InvariantJiraRoute = {
	name: 'global-admin-helper-email-notifications-log',
	path: '/jira/settings/system/notification-logs',
	exact: true,
};
